import React from 'react';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { MenuItem } from '../../components/Menu';
import copyIcon from '../../icons/non-prefilled/16x16/copy.svg';
import { miscToasts } from '../../toasts/toasts';
import { UIActions } from '../../ui/uiSlice';
import { useToolbarOverflowMenuClose } from './toolbar/Toolbar';

interface CopyLinkMenuItemProps {
  link: string;
  children?: string;
}

const CopyLinkMenuItem = ({ link, children }: CopyLinkMenuItemProps) => {
  const closeOverflowMenu = useToolbarOverflowMenuClose();
  const dispatch = useAppDispatch();

  return (
    <MenuItem
      icon={copyIcon}
      onClick={async () => {
        await navigator.clipboard.writeText(link);
        dispatch(UIActions.pushToast(miscToasts.linkCopied));
        closeOverflowMenu();
      }}
      testId="copyLinkMenuItem"
    >
      {children ?? 'Copy link'}
    </MenuItem>
  );
};

export default CopyLinkMenuItem;
